<pr-icon-chip
  [icon]="status | map: statusIcon"
  [iconClass]="status | map: statusColor"
>
  {{ status ?? '' | splitCamel | titlecase }}
</pr-icon-chip>
